// extracted by mini-css-extract-plugin
module.exports =  {"factoid":"_0bc5e8de02--factoid--mKW6H","icon":"_0bc5e8de02--icon--QJ_jj","text":"_0bc5e8de02--text--YDFDl"};